import i18next from 'i18next'
import moment from 'moment/moment'

moment.locale('fr', {
  months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
})
moment.locale(i18next.language)
